export const chemicalTemplate = [
  { header: 'generateReport.dataToResult.report.general.document_version' },
  { header: 'generateReport.dataToResult.report.general.id_ensaio' },
  { header: 'generateReport.dataToResult.report.general.id_hex' },
  { header: 'generateReport.dataToResult.report.general.product' },
  { header: 'generateReport.dataToResult.report.general.product_version' },
  { header: 'generateReport.dataToResult.report.general.date_started' },
  { header: 'generateReport.dataToResult.report.general.observacao_geral' },
  { header: 'generateReport.dataToResult.report.general.text_comentario' },
  { header: 'generateReport.dataToResult.report.test.chemical.analysis' },
  { header: 'generateReport.dataToResult.report.general.planta_origem' },
  { header: 'generateReport.dataToResult.report.general.data_cadastro' },
  { header: 'generateReport.dataToResult.report.general.amostra_mes' },
  { header: 'generateReport.dataToResult.report.general.project' },
  {
    header:
      'generateReport.dataToResult.report.test.chemical.tipo_teste_amostra',
  },
  { header: 'generateReport.dataToResult.report.general.desc_cliente' },
  { header: 'generateReport.dataToResult.report.general.descricao_mes' },
  { header: 'generateReport.dataToResult.report.general.firma_insp' },
  { header: 'generateReport.dataToResult.report.general.pedido' },
  { header: 'generateReport.dataToResult.report.general.item' },
  {
    header: 'generateReport.dataToResult.report.test.chemical.id_numeric_lims',
  },
  { header: 'generateReport.dataToResult.report.general.corrida' },
  { header: 'generateReport.dataToResult.report.test.chemical.numero_peca' },
  {
    header: 'generateReport.dataToResult.report.test.chemical.posicao_amostra',
  },
  { header: 'generateReport.dataToResult.report.general.ordem_de_processo' },
  { header: 'generateReport.dataToResult.report.general.lote_tt' },
  { header: 'generateReport.dataToResult.report.test.chemical.c' },
  { header: 'generateReport.dataToResult.report.test.chemical.mn' },
  { header: 'generateReport.dataToResult.report.test.chemical.p' },
  { header: 'generateReport.dataToResult.report.test.chemical.si' },
  { header: 'generateReport.dataToResult.report.test.chemical.ni' },
  { header: 'generateReport.dataToResult.report.test.chemical.cr' },
  { header: 'generateReport.dataToResult.report.test.chemical.mo' },
  { header: 'generateReport.dataToResult.report.test.chemical.al' },
  { header: 'generateReport.dataToResult.report.test.chemical.cu' },
  { header: 'generateReport.dataToResult.report.test.chemical.v' },
  { header: 'generateReport.dataToResult.report.test.chemical.nb' },
  { header: 'generateReport.dataToResult.report.test.chemical.b' },
  { header: 'generateReport.dataToResult.report.test.chemical.ti' },
  { header: 'generateReport.dataToResult.report.test.chemical.n' },
  { header: 'generateReport.dataToResult.report.test.chemical.sn' },
  { header: 'generateReport.dataToResult.report.test.chemical.pb' },
  { header: 'generateReport.dataToResult.report.test.chemical.as' },
  { header: 'generateReport.dataToResult.report.test.chemical.ca' },
  { header: 'generateReport.dataToResult.report.test.chemical.co' },
  { header: 'generateReport.dataToResult.report.test.chemical.o' },
  { header: 'generateReport.dataToResult.report.test.chemical.h' },
  { header: 'generateReport.dataToResult.report.test.chemical.c_min' },
  { header: 'generateReport.dataToResult.report.test.chemical.c_max' },
  { header: 'generateReport.dataToResult.report.test.chemical.mn_min' },
  { header: 'generateReport.dataToResult.report.test.chemical.mn_max' },
  { header: 'generateReport.dataToResult.report.test.chemical.p_min' },
  { header: 'generateReport.dataToResult.report.test.chemical.p_max' },
  { header: 'generateReport.dataToResult.report.test.chemical.s_min' },
  { header: 'generateReport.dataToResult.report.test.chemical.s_max' },
  { header: 'generateReport.dataToResult.report.test.chemical.ni_min' },
  { header: 'generateReport.dataToResult.report.test.chemical.ni_max' },
  { header: 'generateReport.dataToResult.report.test.chemical.cr_min' },
  { header: 'generateReport.dataToResult.report.test.chemical.cr_max' },
  { header: 'generateReport.dataToResult.report.test.chemical.mo_min' },
  { header: 'generateReport.dataToResult.report.test.chemical.mo_max' },
  { header: 'generateReport.dataToResult.report.test.chemical.al_min' },
  { header: 'generateReport.dataToResult.report.test.chemical.al_max' },
  { header: 'generateReport.dataToResult.report.test.chemical.cu_min' },
  { header: 'generateReport.dataToResult.report.test.chemical.cu_max' },
  { header: 'generateReport.dataToResult.report.test.chemical.v_min' },
  { header: 'generateReport.dataToResult.report.test.chemical.v_max' },
  { header: 'generateReport.dataToResult.report.test.chemical.nb_min' },
  { header: 'generateReport.dataToResult.report.test.chemical.nb_max' },
  { header: 'generateReport.dataToResult.report.test.chemical.b_min' },
  { header: 'generateReport.dataToResult.report.test.chemical.b_max' },
  { header: 'generateReport.dataToResult.report.test.chemical.ti_min' },
  { header: 'generateReport.dataToResult.report.test.chemical.ti_max' },
  { header: 'generateReport.dataToResult.report.test.chemical.n_min' },
  { header: 'generateReport.dataToResult.report.test.chemical.n_max' },
  { header: 'generateReport.dataToResult.report.test.chemical.sn_min' },
  { header: 'generateReport.dataToResult.report.test.chemical.sn_max' },
  { header: 'generateReport.dataToResult.report.test.chemical.pb_min' },
  { header: 'generateReport.dataToResult.report.test.chemical.pb_max' },
  { header: 'generateReport.dataToResult.report.test.chemical.as_min' },
  { header: 'generateReport.dataToResult.report.test.chemical.as_max' },
  { header: 'generateReport.dataToResult.report.test.chemical.ca_min' },
  { header: 'generateReport.dataToResult.report.test.chemical.ca_max' },
  { header: 'generateReport.dataToResult.report.test.chemical.o_min' },
  { header: 'generateReport.dataToResult.report.test.chemical.o_max' },
  { header: 'generateReport.dataToResult.report.test.chemical.h_min' },
  { header: 'generateReport.dataToResult.report.test.chemical.h_max' },

  { header: 'generateReport.dataToResult.report.test.chemical.min_nb_v' },
  { header: 'generateReport.dataToResult.report.test.chemical.max_nb_v' },
  { header: 'generateReport.dataToResult.report.test.chemical.min_nv_v_ti' },
  { header: 'generateReport.dataToResult.report.test.chemical.max_nv_v_ti' },
  { header: 'generateReport.dataToResult.report.test.chemical.min_tl_n' },
  { header: 'generateReport.dataToResult.report.test.chemical.max_tl_n' },
  { header: 'generateReport.dataToResult.report.test.chemical.min_al_n' },
  { header: 'generateReport.dataToResult.report.test.chemical.max_al_n' },
  {
    header: 'generateReport.dataToResult.report.test.chemical.min_cu_ni_cr_mo',
  },
  {
    header: 'generateReport.dataToResult.report.test.chemical.max_cu_ni_cr_mo',
  },
  { header: 'generateReport.dataToResult.report.test.chemical.min_ca_s' },
  { header: 'generateReport.dataToResult.report.test.chemical.max_ca_s' },
  {
    header: 'generateReport.dataToResult.report.test.chemical.min_cr_cu_mo_ni',
  },
  {
    header: 'generateReport.dataToResult.report.test.chemical.max_cr_cu_mo_ni',
  },
  { header: 'generateReport.dataToResult.report.test.chemical.min_mn_c' },
  { header: 'generateReport.dataToResult.report.test.chemical.max_mn_c' },
  { header: 'generateReport.dataToResult.report.test.chemical.min_ni_cu' },
  { header: 'generateReport.dataToResult.report.test.chemical.max_ni_cu' },
  { header: 'generateReport.dataToResult.report.test.chemical.min_p_s' },
  { header: 'generateReport.dataToResult.report.test.chemical.max_p_s' },
  { header: 'generateReport.dataToResult.report.test.chemical.min_ceq' },
  { header: 'generateReport.dataToResult.report.test.chemical.max_ceq' },
  { header: 'generateReport.dataToResult.report.test.chemical.min_pcm' },
  { header: 'generateReport.dataToResult.report.test.chemical.max_pcm' },
]
